import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Table,
  TableRow,
  TableBody,
  TableHeader,
  TableFooter,
  TableRowColumn,
  TableHeaderColumn
} from 'material-ui/Table'
import { RaisedButton, CircularProgress, TextField } from 'material-ui'
import Constants from '../../utils/CommonConstants'
import { getExcel } from '../../actions/dashboard'
import {
  getExcelUrlForSearch,
  getAgents,
  massUpdate,
  downloadExcelRequest,
  CLEAR_EXCEL_URL
} from '../../actions/search'
import FlatButton from 'material-ui/FlatButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import { bindActionCreators } from 'redux'
import Dialog from 'material-ui/Dialog'
import moment from 'moment'
import { List, AutoComplete } from 'material-ui'
import { SHOW_SNACKBAR_TOASTR } from '../../actions/loading'

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    excelUrl: state.excelUrl,
    excelUrlForSearch: state.excelUrlForSearch,
    massUpdateDone: state.massUpdateDone,
    downloadExcelRequestDone: state.downloadExcelRequestDone,
    agents: state.agents
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getExcel: bindActionCreators(getExcel, dispatch),
    getExcelUrlForSearch: bindActionCreators(getExcelUrlForSearch, dispatch),
    getAgents: bindActionCreators(getAgents, dispatch),
    massUpdate: bindActionCreators(massUpdate, dispatch),
    downloadExcelRequest: bindActionCreators(downloadExcelRequest, dispatch),
    dispatch
  }
}
const styles = {
  table: {},
  tableRow: {},
  tableRowColumn: {
    textAlign: 'center'
  },
  tableHeader: {},
  tableHeaderColumn: {
    textAlign: 'center',
    backgroundColor: 'rgba(127, 221, 233, 0.4)',
    borderBottom: 'solid 1px #86adb3',
    color: '#333',
    fontSize: '16px'
  },
  tableBody: {},
  dialogButton: {
    textAlign: 'center'
  }
}

class EntityTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      excelUrl: '',
      openDialog: false,
      shouldHide: true,
      agents: props.agents || [],
      showAskEmailModal: false,
      email: '',
      emailErrorText: null,
      selectedAgentDialog: null
    }
    this.handleSelectedRows = this.handleSelectedRows.bind(this)
    this._selectedRows = []
  }

  static propTypes = {
    fields: PropTypes.array,
    dataArr: PropTypes.array,
    loadMore: PropTypes.func,
    totalCount: PropTypes.number,
    isFetching: PropTypes.bool
  }

  static getHeaderOfTable(fields, title, enableSelectAll) {
    const head = fields.map(field => (
      <TableHeaderColumn style={styles.tableHeaderColumn} key={field.label}>
        {field.label}
      </TableHeaderColumn>
    ))
    return (
      <TableHeader
        style={styles.tableHeader}
        displaySelectAll
        adjustForCheckbox
        enableSelectAll={enableSelectAll}
        style={{ backgroundColor: '#dcdcdc', padding: '5px' }}
      >
        {title && (
          <TableRow style={styles.tableRow}>
            <TableHeaderColumn
              colSpan={fields.length}
              style={styles.tableHeaderColumn}
            >
              {title}
            </TableHeaderColumn>
          </TableRow>
        )}
        <TableRow style={styles.tableRow}>{head}</TableRow>
      </TableHeader>
    )
  }

  static getBodyOfTable(dataArr, fields) {
    let rowCount = 1
    let row
    let link
    const body = dataArr.map(data => {
      row = fields.map(field => {
        if (field.isLink) {
          link = `/detail/${data.rcmOrder.id}`
          return (
            <TableRowColumn
              key={data.rcmOrder.id}
              style={styles.tableRowColumn}
            >
              <Link to={link}>{data.rcmOrder.id}</Link>
            </TableRowColumn>
          )
        }
        return (
          <TableRowColumn
            key={data.rcmOrder.id + field.label}
            style={styles.tableRowColumn}
          >
            {data.rcmOrder[field.field]}
          </TableRowColumn>
        )
      })
      return (
        <TableRow
          selectable={
            Constants.noMassAssignStatusIds.indexOf(data.rcmOrder.statusId) ===
              -1 || data.rcmOrder.statusId === Constants.FINANCE_APPROVED
          }
          key={`row_${rowCount++}`}
          style={styles.tableRow}
        >
          {row}
        </TableRow>
      )
    })
    return (
      <TableBody
        stripedRows
        multiSelectable
        displayRowCheckbox
        deselectOnClickaway={false}
        style={styles.tableBody}
      >
        {body}
      </TableBody>
    )
  }

  getLoadMoreButton = style => {
    let text = this.props.dataArr.length ? (
      <div>
        Showing 1 to {this.props.dataArr.length} of {this.props.totalCount}
      </div>
    ) : null
    if (this.props.totalCount > this.props.dataArr.length) {
      text = (
        <div>
          {text}
          <RaisedButton
            primary
            label='Load More'
            onClick={this.props.loadMore}
          />
        </div>
      )
    }
    return <div style={style}>{text}</div>
  }

  downloadToExcel = () => {
    const { dispatch, userInfo, keyName, caseSubTypeId } = this.props
    let { startDate, endDate } = this.props.location.query
    startDate = new Date(parseInt(startDate))
    endDate = new Date(parseInt(endDate))
    const id = userInfo ? userInfo.id : null,
      start = 0,
      excelName = `${keyName}_data`
    if (this.props.keyName !== undefined) {
      // from dashboard page
      this.props.getExcel(
        excelName,
        id,
        {
          caseSubTypeId,
          paging: { start, rows: this.props.totalCount },
          startDate,
          endDate
        },
        [keyName]
      )
    } else {
      // from search page
      this.props.getExcelUrlForSearch(this.props.filters, this.props.totalCount)
    }
  }

  getAgents() {
    if (this.state.agents.length !== 0) {
      return
    }
    this.props.getAgents()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.excelUrl) {
      this.setState({
        excelUrl: nextProps.excelUrl
      })
    }
    if (nextProps.excelUrlForSearch) {
      this.setState({
        excelUrlForSearch: nextProps.excelUrlForSearch
      })
    }
    if (nextProps.agents) {
      this.setState({
        agents: nextProps.agents
      })
    }
    if (nextProps.massUpdateDone !== this.props.massUpdateDone) {
      this.props.refreshTable()
      this.setState({
        selectedAgentDialog: null,
        openDialog: false
      })
    }
    if (
      nextProps.downloadExcelRequestDone !== this.props.downloadExcelRequestDone
    ) {
      this.handleDialogClose()
    }
  }
  componentWillMount() {
    const { keyName, dispatch, filters } = this.props
    this.downloadToExcel()
    this.getAgents()
  }
  componentWillUnmount() {
    this.props.dispatch({ type: CLEAR_EXCEL_URL })
  }

  handleUpdateAgentDialog = value => {
    if (this.props.agents[value]) {
      const agentName = this.props.agents[value]
      this.setState({
        selectedAgentDialog: agentName
      })
    }
  }

  handleAssignAgentDialog = () => {
    if (this.state.selectedAgentDialog == null) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Select Agent to assign selected Orders'
      })
      return
    }
    const assigneeAgentId = this.state.selectedAgentDialog.id,
      selectedRows = this._selectedRows
    let rcmOrderIds = []
    if (selectedRows == 'all') {
      this.props.dataArr.forEach(data => {
        rcmOrderIds.push(data.rcmOrder.id)
      })
    } else {
      selectedRows.forEach(rowNumber => {
        rcmOrderIds.push(this.props.dataArr[rowNumber].rcmOrder.id)
      })
    }
    const caseSubTypeId = this.props.caseSubTypeId
    this.props.massUpdate({
      rcmOrderIds,
      caseSubTypeId,
      assigneeAgent: this.state.selectedAgentDialog
    })
  }

  handleDialogOpen = () => {
    if (!this._selectedRows.length) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Select orders for Mass Assign.'
      })
      return
    }
    this.setState({ openDialog: true })
  }

  handleDialogClose = () => {
    this.setState({
      openDialog: false,
      showAskEmailModal: false,
      emailErrorText: null,
      email: '',
      selectedAgentDialog: null
    })
  }

  handleSelectedRows = selectedRowsFromTable => {
    if (this.state.openDialog == false) {
      this._selectedRows = selectedRowsFromTable
    }
  }

  askEmail = () => {
    this.setState({
      showAskEmailModal: true
    })
  }

  handleEmailChange = (event, email) => {
    this.setState({
      email,
      emailErrorText: null
    })
  }

  sendDownloadExcelRequest = () => {
    const { email } = this.state
    if (Constants.regex.email.test(email)) {
      const { excelUrl, excelUrlForSearch } = this.props
      const url = `${excelUrl || excelUrlForSearch}&email=${email}`
      this.props.downloadExcelRequest(url)
    } else {
      this.setState({
        emailErrorText: 'Enter a valid email id.'
      })
    }
  }

  render() {
    const styles = {
      buttondiv: {
        margin: '20px auto',
        width: '150px',
        height: '56px'
      }
    }
    const { agents } = this.props
    const dialogActions = [
      <FlatButton
        label='Assign'
        primary
        onClick={this.handleAssignAgentDialog}
      />
    ]
    const fields = this.props.fields
    const dataArr = this.props.dataArr
    const loadMore = this.getLoadMoreButton(styles.buttondiv)
    const isFetching = this.props.isFetching && (
      <div style={styles.buttondiv}>
        <CircularProgress thickness={5} />
      </div>
    )

    if (!dataArr) return <div>Loading...</div>

    const enableSelectAll =
      dataArr.filter(
        data =>
          Constants.noMassAssignStatusIds.indexOf(data.rcmOrder.statusId) !== -1
      ).length === 0

    const tableHead = EntityTable.getHeaderOfTable(
      fields,
      this.props.title,
      enableSelectAll
    )
    const tableBody = EntityTable.getBodyOfTable(dataArr, fields)

    const { email, emailErrorText } = this.state
    const downloadToExcelUrl =
      this.props.excelUrl || this.props.excelUrlForSearch

    return (
      <div className='entity-list'>
        <br />
        {downloadToExcelUrl && (
          <React.Fragment>
            <div style={{ textAlign: 'right' }}>
              <RaisedButton
                primary
                label='Download to Excel'
                onClick={() => window.open(downloadToExcelUrl, '_blank')}
              />
            </div>
            <br />
          </React.Fragment>
        )}
        <div style={styles.dialogButton}>
          {this.props.showMassAssign && (
            <div style={{ position: 'fixed', right: '0%', bottom: '5%' }}>
              <FloatingActionButton onClick={this.handleDialogOpen}>
                <ContentAdd />
              </FloatingActionButton>
            </div>
          )}

          <Dialog
            title='Select the agent to assign'
            actions={dialogActions}
            modal={false}
            open={this.state.openDialog}
            onRequestClose={this.handleDialogClose}
          >
            <List style={styles.paper}>
              {agents && (
                <AutoComplete
                  hintText='Agent name'
                  filter={AutoComplete.caseInsensitiveFilter}
                  dataSource={Object.keys(agents)}
                  onUpdateInput={this.handleUpdateAgentDialog}
                  maxSearchResults={10}
                />
              )}
            </List>
          </Dialog>
          <Dialog
            title='Enter your Email.'
            actions={[
              <FlatButton
                label='OK'
                primary
                onClick={this.sendDownloadExcelRequest}
              />
            ]}
            modal={false}
            open={this.state.showAskEmailModal}
            onRequestClose={this.handleDialogClose}
          >
            <TextField
              hintText='example@domain.com'
              floatingLabelText='Email'
              value={email || ''}
              errorText={emailErrorText}
              onChange={this.handleEmailChange}
            />
          </Dialog>
        </div>

        <Table
          fixedHeader
          multiSelectable
          onRowSelection={this.handleSelectedRows}
          style={styles.table}
        >
          {tableHead}
          {tableBody}
          <TableFooter>
            <TableRow>
              <TableRowColumn
                colSpan={fields.length}
                style={{ textAlign: 'center' }}
              />
            </TableRow>
          </TableFooter>
        </Table>
        {isFetching || loadMore}
      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EntityTable)



/** WEBPACK FOOTER **
 ** ./src/components/EntityTable/EntityTable.js
 **/